import { FC } from 'react'
import { ContextTag } from 'src/services/aiListeningApi/brandProfile.types'
import styles from './contextTags.module.scss'
import { CONTEXT_TAG_TONES, Pill } from '../Pill'
import { CONTEXT_TAG_LABELS } from '../utils'

interface ContextTagsProps {
  // "Topic · Pricing" (default) or just "Pricing".
  showType?: boolean
  size?: 'md' | 'sm'
  tags: ContextTag[]
}

export const ContextTags: FC<ContextTagsProps> = ({
  showType = true,
  size = 'md',
  tags,
}) => (
  <span className={styles.tags}>
    {tags.map((tag) => (
      <Pill
        className={size === 'md' ? styles.tag : undefined}
        key={`${tag.type}-${tag.value}`}
        size={size}
        tone={CONTEXT_TAG_TONES[tag.type] ?? 'grey'}
      >
        {showType
          ? `${CONTEXT_TAG_LABELS[tag.type] ?? tag.type} · ${tag.value}`
          : tag.value}
      </Pill>
    ))}
  </span>
)

export const SparkleIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
  >
    <path
      d="M7 2.5l1.1 3.4 3.4 1.1-3.4 1.1L7 11.5 5.9 8.1 2.5 7l3.4-1.1L7 2.5zM12.5 10l.5 1.5 1.5.5-1.5.5-.5 1.5-.5-1.5-1.5-.5 1.5-.5.5-1.5z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.1"
    />
  </svg>
)
